import { render, staticRenderFns } from "./ClaimsBookkeeping.vue?vue&type=template&id=3482dcb8&scoped=true"
import script from "./ClaimsBookkeeping.vue?vue&type=script&lang=js"
export * from "./ClaimsBookkeeping.vue?vue&type=script&lang=js"
import style0 from "./ClaimsBookkeeping.vue?vue&type=style&index=0&id=3482dcb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3482dcb8",
  null
  
)

export default component.exports